import React from "react";
import {Col, Row} from "react-bootstrap";
import {RequireAuth} from "Components/Security/RequireAuth";
import {DefaultContainer} from "Views/Shared/DefaultContainer";
import {useNavigate} from "react-router-dom";
import {MonthlyFeeModificationForm} from "Views/MonthlyFeeModification/MonthlyFeeModificationForm";
import {Notificator} from "Services/Notificator/Notificator";
import {ROUTE_PATHS} from "Config/Router/Routes";
import {useMutation} from "react-query";
import {createMonthlyFeeModification, CreateMonthlyFeeModificationBody} from "Api/Mutation/MonthlyFeeModificationMutation";

export const MonthlyFeeModificationAdd : React.FC = () => {

    const navigate = useNavigate()

    const createMutation = useMutation({
        mutationKey: ['createMonthlyFeeModificationMutation'],
        mutationFn: (body : CreateMonthlyFeeModificationBody) => createMonthlyFeeModification(body),
        onSuccess: () => {
            Notificator.success('La modificación de cuota mensual se ha creado correctamente')
            navigate(ROUTE_PATHS.ADMIN_MONTHLY_FEE_MODIFICATION_LIST)
        },
        onError: (response: any) => {
            const message = response.response?.data?._error?.message 
                ? ('Error: ' + response.response.data._error.message) 
                : 'Se ha producido un error al crear la modificación de cuota mensual.'
            Notificator.error(message)
        }
    })

    const onSave = (formData: {[key:string]:any}) => {
        createMutation.mutate({
            year: formData.year,
            monthNumber: formData.monthNumber,
            childId: formData.childId,
            amount: formData.amount,
            description: formData.description ?? null
        })
    }

    return (
        <RequireAuth>
            <DefaultContainer>

                <Col>

                    <Row>
                        <Col>
                            <h1 className={"pb-4"}>Crear modificación de cuota mensual</h1>
                        </Col>

                    </Row>

                    <Row>
                        <MonthlyFeeModificationForm
                            onSave={onSave}
                        />
                    </Row>

                </Col>

            </DefaultContainer>
        </RequireAuth>
    )
}

